import fetch from "utils/fetch";

export const fetchCapitals = ({ params, ...rest }) => {
  return fetch({
    url: 'capitals',
    method: "GET",
    params,
    ...rest
  });
};

export const fetchCapital = ({ id, params, ...rest }) => {
  return fetch({
    url: `capitals/${id}`,
    method: "GET",
    params,
    ...rest
  });
};

export const createCapital = ({ data, ...rest }) => {
  return fetch({
    url: `capitals`,
    method: "POST",
    data,
    ...rest
  });
};

export const fetchCapitalsWithReportByAccount = ({ params, ...rest }) => {
  return fetch({
    url: 'capitals/reports-by-account',
    method: "GET",
    params,
    ...rest
  });
};

export const fetchCapitalsWithReportByCurrency = ({ params, ...rest }) => {
  return fetch({
    url: 'capitals/reports-by-currency',
    method: "GET",
    params,
    ...rest
  });
};
